import { Box, Link } from "@material-ui/core";
import DateTimeUtils, { FORMAT_TYPE } from "../../../utils/DateTimeUtils";
import Tooltip from "rc-tooltip";
import React from "react";
import OrderRes from "../../../types/res/order/OrderRes";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

type Props = {
  order: OrderRes;
  item: any;
  itemContext: any;
  getItemProps: any;
  rightResizeProps: any;
  leftResizeProps: any;
};

const Item = styled.div<{ color: string }>`
  background-color: ${(props) => props.color} !important;
  border: 1px solid ${(props) => props.color} !important;
  border-radius: 4px;
`;
const DriverScheduleOrderItem: React.FC<Props> = ({
  order,
  item,
  itemContext,
  getItemProps,
  leftResizeProps,
  rightResizeProps,
}) => {
  const { t } = useTranslation("driverShift");
  const notSet = t("driverSchedule.labels.notSet");
  return (
    <Tooltip
      placement="right"
      trigger={["hover"]}
      overlay={
        <Box display="flex" flexDirection="column">
          <span>{t("driverSchedule.tooltipOrder.shopName")}：{order?.shop?.name || notSet} </span>
          <span>{t("driverSchedule.tooltipOrder.guestName")}：{order?.guest?.name || notSet}</span>
          <span>{t("driverSchedule.tooltipOrder.guestTel")}：{order?.guest?.tel || notSet}</span>
          <span>{t("driverSchedule.tooltipOrder.castName")}：{order?.castName?.name || notSet}</span>
          <span>
            {t("driverSchedule.tooltipOrder.totalTime")}：{order?.totalTime ? t("driverSchedule.tooltipOrder.totalTimeMinutes", { minutes: order.totalTime }) : notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.area")}：
            {order?.area?.name || notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.hotel")}：
            {order?.hotel?.name || notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.address")}：
            {order?.orderAddress || notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.address2")}：
            {order?.orderAddress2 || notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.options")}：
            {order?.options?.map((option) => option.name).join("/") || notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.departureTime")}：
            {order?.departureTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order?.departureTime,
                  FORMAT_TYPE.TIME
                )
              : notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.planIn")}：
            {order?.planInTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.planInTime,
                  FORMAT_TYPE.TIME
                )
              : notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.planOut")}：
            {order?.planOutTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.planOutTime,
                  FORMAT_TYPE.TIME
                )
              : notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.actualIn")}：
            {order?.actualInTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.actualInTime,
                  FORMAT_TYPE.TIME
                )
              : notSet}
          </span>
          <span>
            {t("driverSchedule.tooltipOrder.actualOut")}：
            {order?.actualEndTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.actualEndTime,
                  FORMAT_TYPE.TIME
                )
              : notSet}
          </span>
          <Link href={`/order/${order.orderId}`}>{t("driverSchedule.tooltipOrder.orderDetailLink")}</Link>
        </Box>
      }
    >
      <Item {...getItemProps(item.itemProps)} color={item.color}>
        {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}
        <div
          className="rct-item-content"
          style={{
            maxHeight: `${itemContext.dimensions.height}`,
            overflow: "hidden",
            padding: "0 2px",
            fontSize: "8px",
          }}
        >
          {itemContext.title}
        </div>
        <div
          style={{
            height: itemContext.dimensions.height,
          }}
        />
        {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
      </Item>
    </Tooltip>
  );
};

export default DriverScheduleOrderItem;
